import { render, staticRenderFns } from "./geo_general.vue?vue&type=template&id=13ce27e5"
import script from "./geo_general.vue?vue&type=script&lang=js"
export * from "./geo_general.vue?vue&type=script&lang=js"
import style0 from "./geo_general.vue?vue&type=style&index=0&id=13ce27e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports